import ranking1Icon from '@assets/images/pump/ranking_1.svg';
import ranking2Icon from '@assets/images/pump/ranking_2.svg';
import ranking3Icon from '@assets/images/pump/ranking_3.svg';

export const rankingIcons = [ranking1Icon, ranking2Icon, ranking3Icon];
